odoo.define("@odoo/owl", [], function () {
    "use strict";

    return owl;
});
